import React, { useState } from 'react';

import classNames from 'classnames';
import CopyIcon from 'icons/copy.svg';
import TickIcon from 'icons/ic-tick.svg';
import PropTypes from 'prop-types';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useTranslation } from 'react-i18next';
import voca from 'voca';

export default function CopyableField({ name, value }) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const [isCopied, setIsCopied] = useState(false);

  return (
    <div className='tw-flex'>
      <input
        className='field__input tw-border-grey-300 tw-bg-grey-050 tw-font-inter tw-text-m tw-font-normal tw-tracking-auto placeholder:tw-text-grey-300 focus-within:tw-border-blue-300 hover:tw-border-grey-400 hover:focus-within:tw-border-blue-300'
        id={voca.snakeCase(name)}
        name={name}
        readOnly='readonly'
        type='text'
        value={value}
      />
      <div
        className='copyable__hit-area tw-group/hit tw-h-10 tw-w-10 tw-p-2.5'
        onMouseEnter={() => setIsCopied(false)}
      >
        <div className='copyable tw-text-s tw-font-medium tw-tracking-wide'>
          <div className='copyable__copy-icon-wrapper'>
            <CopyToClipboard onCopy={() => setIsCopied(true)} text={value}>
              <CopyIcon
                className='[&_path]:tw-fill-grey-500 group-hover/hit:[&_path]:tw-fill-blue-500'
                height={20}
                width={20}
              />
            </CopyToClipboard>
          </div>
          <div
            className={classNames(
              'copyable__tooltip copyable__tooltip--center tw-bg-grey-900 tw-text-white',
              isCopied && 'copyable__tooltip--ease-out',
            )}
          >
            {isCopied ?
              <div className='copyable__tooltip-content'>
                <TickIcon className='copyable__tick-icon [&_polygon]:tw-fill-white' />
                <span>{i18nTShared('copiedToClipboard')}</span>
              </div>
            : <span className='copyable__tooltip-content'>
                <span>{i18nTShared('clickToCopyToClipboard')}</span>
              </span>
            }
          </div>
        </div>
      </div>
    </div>
  );
}

CopyableField.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};
